import heroSections from '../templates/hero-sections'
import featureSections from '../templates/feature-sections'
import ctaSections from '../templates/cta-sections'
import testimonialSections from '../templates/testimonial-sections'
import footerSections from '../templates/footer-sections'
import eventSections from '../templates/event-sections'
import emailSections from '../templates/email-sections'

const SAVED_BLOCKS_KEY = 'eb-saved-blocks'

const ALL_TEMPLATES = [
  ...heroSections,
  ...featureSections,
  ...ctaSections,
  ...testimonialSections,
  ...footerSections,
  ...eventSections,
  ...emailSections,
]

const CATEGORIES = ['Hero', 'Features', 'CTA', 'Testimonials', 'Footer', 'Event', 'Email', 'Saved']

export default function elementorTemplates(editor) {
  function getSavedBlocks() {
    try {
      return JSON.parse(localStorage.getItem(SAVED_BLOCKS_KEY) || '[]')
    } catch (e) { return [] }
  }

  function saveSavedBlocks(blocks) {
    localStorage.setItem(SAVED_BLOCKS_KEY, JSON.stringify(blocks))
  }

  editor.Commands.add('open-templates', {
    run() {
      const sidebar = document.querySelector('.eb-sidebar-body')
      if (!sidebar) return

      sidebar.querySelectorAll('.eb-panel-view').forEach(v => v.style.display = 'none')

      let panel = sidebar.querySelector('.eb-templates-panel')
      if (panel) {
        panel.style.display = 'block'
        return
      }

      panel = document.createElement('div')
      panel.className = 'eb-templates-panel eb-panel-view'

      const header = document.createElement('div')
      header.className = 'eb-tpl-header'
      header.innerHTML = '<h3 style="margin:0;font-size:14px;font-weight:700;">Section Templates</h3><p style="margin:4px 0 0;font-size:11px;color:#adb5bd;">Click to insert into page</p>'
      panel.appendChild(header)

      const catFilter = document.createElement('div')
      catFilter.className = 'eb-tpl-cats'
      const allBtn = document.createElement('button')
      allBtn.className = 'eb-tpl-cat-btn active'
      allBtn.textContent = 'All'
      allBtn.addEventListener('click', () => filterCategory('All', catFilter, grid))
      catFilter.appendChild(allBtn)
      CATEGORIES.forEach(cat => {
        const btn = document.createElement('button')
        btn.className = 'eb-tpl-cat-btn'
        btn.textContent = cat
        btn.addEventListener('click', () => filterCategory(cat, catFilter, grid))
        catFilter.appendChild(btn)
      })
      panel.appendChild(catFilter)

      const grid = document.createElement('div')
      grid.className = 'eb-tpl-grid'
      renderTemplates(grid, 'All')
      panel.appendChild(grid)

      sidebar.appendChild(panel)
      panel.style.display = 'block'
    },
    stop() {
      const panel = document.querySelector('.eb-templates-panel')
      if (panel) panel.style.display = 'none'
    },
  })

  function filterCategory(cat, catFilter, grid) {
    catFilter.querySelectorAll('.eb-tpl-cat-btn').forEach(b => b.classList.remove('active'))
    const active = catFilter.querySelector(`.eb-tpl-cat-btn:nth-child(${cat === 'All' ? 1 : CATEGORIES.indexOf(cat) + 2})`)
    if (active) active.classList.add('active')
    renderTemplates(grid, cat)
  }

  function renderTemplates(grid, category) {
    grid.innerHTML = ''
    let templates = category === 'All' ? ALL_TEMPLATES : ALL_TEMPLATES.filter(t => t.category === category)

    if (category === 'All' || category === 'Saved') {
      const saved = getSavedBlocks()
      saved.forEach(block => {
        templates.push({
          id: block.id,
          name: block.name,
          category: 'Saved',
          thumbnail: '<div style="background:#2a2a3e;height:100%;display:flex;align-items:center;justify-content:center;"><div style="text-align:center;color:rgba(255,255,255,0.4);"><i class="fa fa-bookmark" style="font-size:16px;"></i><div style="font-size:4px;margin-top:3px;">Saved</div></div></div>',
          html: block.html,
          isSaved: true,
        })
      })
    }

    templates.forEach(tpl => {
      const card = document.createElement('div')
      card.className = 'eb-tpl-card'
      card.setAttribute('data-category', tpl.category)
      card.innerHTML = `
        <div class="eb-tpl-preview">${tpl.thumbnail}</div>
        <div class="eb-tpl-info">
          <span class="eb-tpl-name">${tpl.name}</span>
          <span class="eb-tpl-cat-badge">${tpl.category}</span>
          ${tpl.isSaved ? '<button class="eb-tpl-delete" title="Delete saved block"><i class="fa fa-trash"></i></button>' : ''}
        </div>
      `

      card.querySelector('.eb-tpl-preview').addEventListener('click', () => {
        editor.DomComponents.getWrapper().append(tpl.html)
      })

      const deleteBtn = card.querySelector('.eb-tpl-delete')
      if (deleteBtn) {
        deleteBtn.addEventListener('click', (e) => {
          e.stopPropagation()
          const saved = getSavedBlocks().filter(b => b.id !== tpl.id)
          saveSavedBlocks(saved)
          renderTemplates(grid, category)
        })
      }

      grid.appendChild(card)
    })

    if (!templates.length) {
      grid.innerHTML = '<div style="padding:20px;text-align:center;color:rgba(255,255,255,0.4);font-size:12px;">No templates in this category</div>'
    }
  }

  editor.Commands.add('save-as-block', {
    run(editor) {
      const selected = editor.getSelected()
      if (!selected) return

      const html = selected.toHTML()
      const name = prompt('Enter a name for this saved block:')
      if (!name) return

      const saved = getSavedBlocks()
      saved.push({
        id: `saved-${Date.now()}`,
        name,
        html,
        createdAt: new Date().toISOString(),
      })
      saveSavedBlocks(saved)

      const grid = document.querySelector('.eb-tpl-grid')
      if (grid) {
        const catFilter = document.querySelector('.eb-tpl-cats')
        const activeCat = catFilter ? catFilter.querySelector('.eb-tpl-cat-btn.active')?.textContent || 'All' : 'All'
        renderTemplates(grid, activeCat)
      }
    },
  })

  editor.on('component:selected', (component) => {
    const type = component.get('type')
    if (type === 'eb-section' || type === 'wrapper') {
      const toolbar = component.get('toolbar') || []
      const hasSave = toolbar.some(t => t.command === 'save-as-block')
      if (!hasSave) {
        component.set('toolbar', [
          ...toolbar,
          {
            attributes: { class: 'fa fa-bookmark', title: 'Save as Block' },
            command: 'save-as-block',
          },
        ])
      }
    }
  })
}
